import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEditSendToLanes extends Layout {
    labelTitle: Label;
    sourcePnnLane: DataSource;
    tableLanes: Table;
}
